module.exports = __webpack_public_path__ + "static/media/nav_tracking.3702f611.svg";